export class AiModelAssignmentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiModelAssignments({ signal, ...params } = {}) {
    return this.#http.get('/ai-model-assignments', { params, signal });
  }

  async createAiModelAssignment(body) {
    return this.#http.post('/ai-model-assignments', body);
  }

  async updateAiModelAssignment({ id, ...body }) {
    return this.#http.put(`/ai-model-assignments/${id}`, body);
  }

  async deleteAiModelAssignment(id) {
    return this.#http.delete(`/ai-model-assignments/${id}`);
  }
}
